import * as yup from 'yup';
import { yupRequiredNonEmptyString } from '../utils/yupRequiredNonEmptyString';

export const CollectionSchema = yup.object().shape({
  id: yupRequiredNonEmptyString('ID'),
  cameraID: yupRequiredNonEmptyString('Camera ID'),
  ssdID: yupRequiredNonEmptyString('SSD ID'),
  collectionDate: yupRequiredNonEmptyString('Collection date'),
  objectVersion: yup.string().nullable(),
  flashVersion: yup.string().nullable(),
  appVersion: yup.string().nullable(),
  noLogin: yup.boolean().nullable(),
  junk: yup.boolean().nullable(),
  fromDate: yupRequiredNonEmptyString('From date'),
  thruDate: yup.string().nullable(),
});

export type Collection = yup.InferType<typeof CollectionSchema>;
